import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import NavBar from "@/components/common/NavBar.vue"
import FooterComponent from "./components/common/FooterComponent.vue";
// import { debounce } from "lodash";
//pnpm install @vueuse/core
// 防抖函数  --> 弹出层导致的问题
// const _ = (window as any).ResizeObserver;
// (window as any).ResizeObserver = class ResizeObserver extends _ {
//   constructor(callback: (...args: any[]) => void) {
//     callback = debounce(callback, 100);
//     super(callback);
//   }
// };

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavBar),
    _createVNode(_component_router_view),
    _createVNode(FooterComponent)
  ], 64))
}
}

})